import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'

// Portal page data - reset by resetPortalState on every login (see resetPortalStores)
const defaultState = () => ({
  isLoaded: false,
  noticeList: []
})

const state = defaultState()
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPortalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
